import i18n from "../../../../i18n";
import { CreateAssessmentFooter } from "../../assessments-page/verity-assessment/shared";
import { baseTransKey } from "../takeAssessmentHelper";
import styles from "../index.module.css";

type TakeAssessmentFooterProps = {
	onSubmit: () => void;
	disabled?: boolean;
	loading?: boolean;
	text?: string;
	disabledTooltip?: string;
};

export default function TakeAssessmentFooter({
	onSubmit,
	disabled = false,
	loading = false,
	text = i18n.t(`${baseTransKey}.submit`),
	disabledTooltip,
}: TakeAssessmentFooterProps) {
	return (
		<CreateAssessmentFooter
			className={styles.takeAssessmentFooter}
			slotProps={{
				next: { onClick: onSubmit, text, disabled: disabled, loading: loading, disabledTooltip },
			}}
		/>
	);
}
